// share-table-report"
import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    tableId = '0',
    rowId = '0',
    password = '',
    expired = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(`${URLS.das.utableData.shareTableReport}`, {
        tableId: Number.parseInt(tableId, 10) || 0,
        rowId: Number.parseInt(rowId, 10) || 0,
        password,
        expired,
    }, options);
    if (error) return { error, status };
    return content || {};
};
